import { Component, OnInit } from '@angular/core';
import * as Constants from '@emi/shared/constants';
import { fetchContactUsTechSupport, getHelpResourcesState, HelpResourcesState } from '@emi/shared/state/help-resources';
import { Store } from '@ngrx/store';

@Component({
    selector: 'via-technical-support',
    templateUrl: './technical-support.component.html',
    styleUrls: ['./technical-support.component.scss'],
})
export class TechnicalSupportComponent implements OnInit {
    public supportMessage: string = Constants.SupportMessages.CONTACT_SUPPORT_MESSAGE;
    public techSupportData: any;

    constructor(private store: Store<HelpResourcesState>) { }

    public ngOnInit(): void {
        this.store.dispatch(fetchContactUsTechSupport());
        this.store.select(getHelpResourcesState).subscribe((state) => {
            this.techSupportData = state.techSupport;
        });
    }
}
